import { render } from "./TreeItem.vue?vue&type=template&id=a0aa0106"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__